import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Breadcrumb.css";

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter(Boolean);

  const formatName = (name) =>
    name
      .replace(/-/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
      .replace(/\b\w/g, (c) => c.toUpperCase());

  const breadcrumbItems = [
    <Link key="home" to="/" className="indec-breadcrumb-link">
      Home
    </Link>,
  ];

  pathnames.forEach((segment, index) => {
    let routeTo = "/" + pathnames.slice(0, index + 1).join("/");

    if (segment === "product") {
      routeTo = "/products";
    }

    const isLast = index === pathnames.length - 1;

    const displayName =
      segment === "product"
        ? "Products"
        : segment === "mosquitonetwindows"
        ? "Mosquito Net Windows"
        : segment === "mosquitonetdoors"
        ? "Mosquito Net Doors"
        : segment === "wallpapers"
        ? "WallPapers"
        : formatName(segment);

    breadcrumbItems.push(
      isLast ? (
        <span key={routeTo} className="indec-breadcrumb-last active">
          {displayName}
        </span>
      ) : (
        <Link key={routeTo} to={routeTo} className="indec-breadcrumb-link">
          {displayName}
        </Link>
      )
    );
  });

  return (
    <div className="indec-breadcrumb-wrapper container">
      <nav className="indec-breadcrumb">{breadcrumbItems}</nav>
    </div>
  );
};

export default Breadcrumbs;
